var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPlusMsg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33325 2.5V3.83333H1.66659V12.7567L2.84192 11.8333H12.3333V7.16667H13.6666V12.5C13.6666 12.6768 13.5963 12.8464 13.4713 12.9714C13.3463 13.0964 13.1767 13.1667 12.9999 13.1667H3.30325L0.333252 15.5V3.16667C0.333252 2.98986 0.40349 2.82029 0.528514 2.69526C0.653538 2.57024 0.823108 2.5 0.999919 2.5H8.33325ZM11.6666 2.5V0.5H12.9999V2.5H14.9999V3.83333H12.9999V5.83333H11.6666V3.83333H9.66659V2.5H11.6666Z",
    fill: "#00A9FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlusMsg);
export default __webpack_public_path__ + "static/media/ic_plus_msg.218e16b19925fbf772e728b576cb54b9.svg";
export { ForwardRef as ReactComponent };